import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Chip,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { ActionsTable, SrCurrency, SrCardsLogos } from "components/common";
import translate from "../../../../i18n/translate";
import { useStyles } from "../../../tableStyles";

const TableLoader = () => (
  <Box display="flex">
    <CircularProgress />
  </Box>
);

const CashPaymentTable = ({
  transactions,
  loading,
  paginationConfig,
  toastSuccess,
}) => {
  const classes = useStyles();

  const chipStatus = {
    1: {
      color: "default",
      label: translate("common.created"),
    },
    2: {
      color: "default",
      label: translate("common.pending"),
    },
    3: {
      color: "secondary",
      label: translate("common.expired"),
    },
    4: {
      color: "primary",
      label: translate("common.paid"),
    },
    5: {
      color: "secondary",
      label: translate("common.declined"),
    },
    6: {
      color: "secondary",
      label: translate("common.error"),
    },
  };

  return (
    <>
      {transactions?.rows?.length ? (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {translate("common.concept")}
                  </TableCell>
                  <TableCell align="center">
                    {translate("common.status")}
                  </TableCell>
                  <TableCell align="center">
                    {translate("common.amount")}
                  </TableCell>
                  <TableCell align="center">
                    {translate("cashPayment.getBallots.dateIssued")}
                  </TableCell>
                  <TableCell align="center">
                    {translate("common.type")}
                  </TableCell>
                  <TableCell align="center">
                    {translate("common.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              {!loading && (
                <TableBody classes={classes.stripped}>
                  {transactions.rows.map((row) => (
                    <TableRow key={row.key}>
                      <TableCell align="left">{row.reference}</TableCell>
                      <TableCell align="center" style={{ padding: 0 }}>
                        <Chip
                          label={
                            chipStatus?.[row.status]?.label ||
                            translate("common.error")
                          }
                          color={chipStatus?.[row.status]?.color || "secondary"}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Typography className={classes.amount}>
                          <SrCurrency value={row.amount} />
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">
                        <SrCardsLogos
                          width="48px"
                          height="22px"
                          imageKey={row.type}
                        />
                      </TableCell>
                      <TableCell align="center" style={{ padding: 0 }}>
                        {row.status !== 3 && (
                          <ActionsTable url={row.url} type="ticket" />
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
            {loading && <TableLoader />}
            {paginationConfig && (
              <TablePagination
                rowsPerPageOptions={paginationConfig.rowsPerPageOptions}
                component="div"
                count={paginationConfig.total}
                rowsPerPage={paginationConfig.limit}
                labelRowsPerPage={translate("common.rowsPerPage")}
                page={paginationConfig.page}
                onPageChange={paginationConfig.onPageChange}
                onRowsPerPageChange={paginationConfig.onRowsPerPageChange}
              />
            )}
          </TableContainer>
        </>
      ) : (
        <Grid container justifyContent="center" spacing={2}>
          <Typography className={classes.noData}>
            {translate("errors.noItemsToShow")}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default CashPaymentTable;
